import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import 'yup-phone';

import TextInput from '../TextInput';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import styles from './CreateFreeAccount.module.scss';

const { updateUserPackageInfo, resetPlanPackageUpdated } = authUserOperations;

const { 'create-free-accnt': createFreeAccntClass, 'form-container': formContainerClass } = styles;

const CreateFreeAccount = () => {
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ authUser }) => ({
    authUser
  }));
  const { data: authUserData, planPackageUpdated } = authUser ?? {};
  const titleCopy = 'Save your plan so you can always get back';

  const userPhoneSchema = Yup.object().shape({
    phone: Yup.string()
      .phone('US', true, 'Please enter a valid phone number.')
      .required('Phone is required')
  });

  //update copy on success
  useEffect(() => {
    if (planPackageUpdated) {
      dispatch(resetPlanPackageUpdated());
    }
  }, [planPackageUpdated]);

  const handleSubmit = ({ phone }) => {
    const strippedPhone = phone?.replace(/\D+/g, '');
    const userInfo = {
      ...authUserData.preneed.userInfo,
      phone: strippedPhone
    };
    dispatch(updateUserPackageInfo({ userInfo }));
  };

  return (
    <Formik
      initialValues={{ phone: '' }}
      validationSchema={userPhoneSchema}
      onSubmit={handleSubmit}
      validateOnMount
    >
      {({ isValid, values, handleSubmit }) => (
        <div className={createFreeAccntClass}>
          <h3>{titleCopy}</h3>
          <div className={formContainerClass}>
            <Form>
              <TextInput type="tel" name="phone" placeholder="Your phone number" />
              <button disabled={!isValid} onClick={handleSubmit} type="submit">
                Create Account
              </button>
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default CreateFreeAccount;
